import { atom } from 'recoil';

import { SelectedTrainingEntity, SelectedUsageItem, UsageType } from './types';

const selectedBillingPeriodIndexState = atom<number>({
  key: 'selected-billing-period-index',
  default: 0,
});

const selectedUsageItemState = atom<SelectedUsageItem>({
  key: 'selected-usage-item',
  default: null,
});

const selectedOrgSharedEndpointIdState = atom<string>({
  key: 'selected-org-shared-endpoint-id',
  default: null,
});

const selectedTrainingEntityState = atom<SelectedTrainingEntity>({
  key: 'selected-training-entity',
  default: null,
});

const selectedUsageTypeState = atom<UsageType>({
  key: 'selected-usage-type',
  default: UsageType.Deployments,
});

export {
  selectedUsageTypeState,
  selectedBillingPeriodIndexState,
  selectedUsageItemState,
  selectedOrgSharedEndpointIdState,
  selectedTrainingEntityState,
};
